export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/dealerIcon.09f61c93.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};